import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateDealer } from '../services/dealers';
import { dealerKeys } from './useDealersQuery';
import type { UpdateDealerPayload, Dealer } from '../types/dealers.types';

export const useUpdateDealerMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<Dealer, Error, { id: string; payload: UpdateDealerPayload }>({
        mutationFn: ({ id, payload }) => updateDealer(id, payload),
        onSuccess: (_, { id }) => {
            queryClient.invalidateQueries({ queryKey: dealerKeys.detail(id) });
            queryClient.invalidateQueries({ queryKey: dealerKeys.lists() });
        },
    });
};
